export default __webpack_public_path__ + "static/media/chevrons-left.545e7ee2.svg";